import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Chip } from 'primereact/chip';
import { Fieldset } from 'primereact/fieldset';
import { useState, useEffect, useRef } from 'react';
import FormCrearProductoFicha from './FormCrearProductoFicha';
import { MAX_LARGO_DESCRIPCION } from '../../../utilities/textValidations.js';
import { Steps } from "primereact/steps";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { ProductService } from "../../../services/ProductService.js";
import useRemarcadores from "../hooks/useRemarcadores.js";

const productService = new ProductService();


const FormCrearProducto = ({
    displayDialog,
    setDisplayDialog,
    producto,
    setProducto,
    tipoProductoOptions,
    handleCreateProducto,
    baseUrl,
    urlMedidores,
    empresa,
    nombreEmpresa,
    loading3
}) => {
    const [activeStep, setActiveStep] = useState(0);
    const stepsItems = [{ label: "Producto", command: () => setActiveStep(0) },{ label: "Ficha técnica", command: () => setActiveStep(1) },];
    const handleStepChange = (e) => {setActiveStep(e.index);};
    const [productos, setProductos] = useState([]);
    const [loading2, setLoading2] = useState(false);
    const {
        tiposRemarcador,
        proveedoresRemarcador,
        loadingTiposRemarcador,
        loadingProveedoresRemarcador,
        fetchTiposRemarcador,
        fetchProveedoresRemarcador,
    } = useRemarcadores(urlMedidores);
    const [tipoRemarcadorId, setTipoRemarcadorId] = useState(null);
    const [proveedorRemarcadorId, setProveedorRemarcadorId] = useState(null);
    const [lecturaInicial, setLecturaInicial] = useState(null);
    const [qrCode, setQrCode] = useState(null);
    const [nuevoRemarcadores, setNuevoRemarcadores] = useState([]);
    const [indiceEdicionRemarcador, setIndiceEdicionRemarcador] = useState(null);
    const fichaRef = useRef(null);
    const [perfil, setPerfil] = useState("");
    const [ficha, setFicha] = useState("");

    const fetchData = async () => {
        try {
            if (empresa) {
                setLoading2(true);
                const productosData = await productService.getProductosByEmpresa(baseUrl, nombreEmpresa);
                setProductos(productosData);
            }
        } catch (error) {
            console.error("Error al obtener los productos:", error);
        } finally {
            setLoading2(false);
        }
    };



    useEffect(() => {
        if (displayDialog && empresa) {
            fetchData();
            fetchTiposRemarcador();
            fetchProveedoresRemarcador();
        }
    }, [displayDialog, empresa]);



    const tiposRemarcadorDisponibles = tiposRemarcador.filter(
        (tipo) =>
            !nuevoRemarcadores.some(
                (item) => item.tipoRemarcadorId === tipo.id && item.id !== indiceEdicionRemarcador
            )
    );

    const limpiarFormularioRemarcador = () => {
        setTipoRemarcadorId(null);
        setProveedorRemarcadorId(null);
        setLecturaInicial(null);
        setIndiceEdicionRemarcador(null);
        setQrCode(null);
    };

    const handleGuardarRemarcador = () => {
        const tipo = tiposRemarcador.find((item) => item.id === tipoRemarcadorId);
        const proveedor = proveedoresRemarcador.find((item) => item.id === proveedorRemarcadorId);
        if (!tipo || !proveedor || lecturaInicial === null || lecturaInicial === undefined) return;

        const existeTipo = nuevoRemarcadores.some(
            (item) => item.tipoRemarcadorId === tipo.id && item.id !== indiceEdicionRemarcador
        );

        if (existeTipo) {
            alert("Solo se permite 1 remarcador por tipo.");
            return;
        }

        const remarcador = {
            id: indiceEdicionRemarcador ?? Date.now(),
            tipoRemarcadorId: tipo.id,
            tipoRemarcador: tipo.descripcion,
            proveedorId: proveedor.id,
            proveedor: proveedor.razonSocial,
            lecturaInicial,
            qrCode,
        };

        const actualizados = indiceEdicionRemarcador !== null
            ? nuevoRemarcadores.map((item) => item.id === indiceEdicionRemarcador ? remarcador : item)
            : [...nuevoRemarcadores, remarcador];

        setNuevoRemarcadores(actualizados);
        setProducto((prev) => ({ ...prev, remarcadores: actualizados }));
        limpiarFormularioRemarcador();
    };

    const handleEditarRemarcador = (rowData) => {
        setTipoRemarcadorId(rowData.tipoRemarcadorId);
        setProveedorRemarcadorId(rowData.proveedorId);
        setLecturaInicial(rowData.lecturaInicial);
        setQrCode(rowData.qrCode);
        setIndiceEdicionRemarcador(rowData.id);
    };

    const handleEliminarRemarcador = (rowData) => {
        const actualizados = nuevoRemarcadores.filter((item) => item.id !== rowData.id);
        setNuevoRemarcadores(actualizados);
        setProducto((prev) => ({ ...prev, remarcadores: actualizados }));
        if (indiceEdicionRemarcador === rowData.id) limpiarFormularioRemarcador();
    };

    const limpiarFormulario = () => {
        setProducto({ descripcion: "", metraje: "", tipoProducto: "", productosAdyacentes: [] });
        setNuevoRemarcadores([]);
        limpiarFormularioRemarcador();
        setDisplayDialog(false);
    };

    const removerProductoAdyacente = (index) => {
        const productosActualizados = producto.productosAdyacentes.filter((_, i) => i !== index);
        setProducto({ ...producto, productosAdyacentes: productosActualizados });
    };

    //LLAMA A CREAR PRODUCTO Y DESPUES FICHA
    const handleCrearProducto = async () => {
        try {
            // Llamar a la función original de crear producto
            const resultado = await handleCreateProducto();
            if (resultado && resultado.producto && resultado.producto.id) {
                const idProducto = resultado.producto.id;
                // Llamar a la función para crear la ficha técnica con el ID del producto
                await handleCrearProductoFicha(idProducto);
                setDisplayDialog(false);
            }
        } catch (error) {
            console.error("Error al crear producto:", error);
            setDisplayDialog(false);
        }
    };

    const handleCrearProductoFicha = async (idProducto) => {
        try {
            // Obtener los datos del componente FormCrearProductoFicha a través de la referencia
            if (fichaRef.current) {
                const fichaData = fichaRef.current.getData();

                await productService.createProductoFicha(baseUrl, {
                    idProducto: idProducto,
                    perfil: fichaData.perfil,
                    ficha: fichaData.fichaJson
                });

                return true;
            }
            return false;
        } catch (error) {
            console.error("Error al crear ficha técnica:", error);
            return false;
        }
    };

    const footerCrearProd = () => {
        return (
            <div className="p-d-flex p-jc-end p-mt-3">
                <Button
                    label="Cancelar"
                    icon="pi pi-times"
                    onClick={limpiarFormulario}
                    className="p-button p-mr-2 p-button-outlined p-button-rounded p-button"
                    raised
                />
                <Button
                    label="Guardar"
                    icon={loading3 ? "pi pi-spin pi-spinner" : "pi pi-save"}
                    onClick={handleCrearProducto}
                    className="p-button-success p-button-rounded p-button"
                    raised
                    autoFocus
                    disabled={loading3 || !producto.descripcion || !producto.metraje || !producto.tipoProducto}
                />
            </div>
        );
    };

    return (
        <div className="form-container">
            <Dialog
                visible={displayDialog}
                onHide={limpiarFormulario}
                className="p-fluid product-dialog"
                footer={footerCrearProd()}
                header={`Crear Producto de ${nombreEmpresa || "sin nombre"}`}
            >
                <Steps 
                    model={stepsItems} 
                    activeIndex={activeStep} 
                    onSelect={handleStepChange}
                    className="cursor-pointer"
                    style={{ cursor: 'pointer' }}
                    readOnly={false}
                />
                
                {activeStep === 0 && (
                    <div className="card">
                        <h6 className="mb-3">
                            Información
                        </h6>
                        {/* Tipo de Producto */}
                        <span className="p-float-label mt-2 mb-3">
                            <Dropdown
                                id="tipoProducto"
                                value={producto.tipoProducto}
                                options={tipoProductoOptions}
                                onChange={(e) => {
                                    setProducto({ 
                                        ...producto, 
                                        tipoProducto: e.value
                                    });
                                }}
                                optionLabel="descripcion"
                                placeholder="Seleccione el tipo de producto"
                                required
                                className="p-inputtext-lg"
                            />
                            <label htmlFor="tipoProducto">
                                <i className="pi pi-tag mr-2"></i>Tipo de Producto: {nombreEmpresa}*
                            </label>
                        </span>
                        
                        {/* Descripción del Producto */}
                        <span className="p-float-label mt-2 mb-3">
                            <InputText
                                id="descripcion"
                                value={producto.descripcion}
                                onChange={(e) =>
                                    setProducto({
                                        ...producto,
                                        descripcion: e.target.value.toUpperCase(),
                                    })
                                }
                                className="p-inputtext-lg"
                                placeholder="Ingrese la descripción del producto"
                                required
                                maxLength={MAX_LARGO_DESCRIPCION}
                            />
                            <label htmlFor="descripcion">
                                <i className="pi pi-file-edit mr-2"></i>Descripción *
                            </label>
                        </span>

                        {/* Metraje del Producto */}
                        <span className="p-float-label mt-2 mb-3">
                            <InputNumber
                                id="metraje"
                                value={producto.metraje === "" ? null : producto.metraje}
                                onValueChange={(e) => setProducto({ ...producto, metraje: e.value })}
                                className="p-inputtext-lg"
                                placeholder="Ingrese el metraje del producto"
                                required
                                min={0}
                                max={10000}
                                locale="es-ES"
                                inputMode="numeric"
                                step={1}
                                minFractionDigits={0}
                                maxFractionDigits={0}
                                allowEmpty
                            />
                            <label htmlFor="metraje"><i className="pi pi-th-large mr-1"></i>Metraje del Producto (m²) *</label>
                        </span>

                        {/* Sección de remarcadores */}
                        <Fieldset
                            legend="Remarcadores"
                            toggleable  
                            className="mt-4 mb-3"
                        >

                            {/* Título */}
                            <p className="text-sm text-muted mb-2">
                                Configure los remarcadores de este producto.
                            </p>
                            <small className="block mb-3" style={{ color: "#6c757d" }}>
                                Debe ingresar al menos 1 remarcador y solo se permite 1 por cada tipo.
                            </small>

                            {/* Formulario */}
                            {/* tipo remarcador */}
                            <span className="p-float-label mb-3">
                                <Dropdown
                                    value={tipoRemarcadorId}
                                    options={tiposRemarcadorDisponibles}
                                    onChange={(e) => {
                                        setTipoRemarcadorId(e.value);
                                        setProveedorRemarcadorId(null);
                                    }}
                                    optionLabel="descripcion"
                                    optionValue="id"
                                    placeholder={loadingTiposRemarcador ? 'Cargando tipos...' : 'Seleccione tipo'}
                                    disabled={loadingTiposRemarcador}
                                    showClear
                                />
                                <label>Tipo Remarcador *</label>
                            </span>  
                            {/* Proveedor */}
                            <span className="p-float-label mb-3">
                                <Dropdown
                                    value={proveedorRemarcadorId}
                                    options={proveedoresRemarcador.filter(
                                        (proveedor) => proveedor.tipoProveedor?.id === tipoRemarcadorId
                                    )}
                                    onChange={(e) => setProveedorRemarcadorId(e.value)}
                                    optionLabel="razonSocial"
                                    optionValue="id"
                                    placeholder={
                                        !tipoRemarcadorId
                                            ? 'Seleccione tipo primero'
                                            : loadingProveedoresRemarcador
                                                ? 'Cargando proveedores...'
                                                : 'Seleccione proveedor'
                                    }
                                    disabled={!tipoRemarcadorId || loadingProveedoresRemarcador}
                                    showClear
                                />
                                <label>Proveedor *</label>
                            </span>

                            <span className="p-float-label mb-3">
                                <InputNumber
                                    inputId="lecturaInicial"
                                    value={lecturaInicial}
                                    onValueChange={(e) => setLecturaInicial(e.value)}
                                    useGrouping={false}
                                    min={0}
                                />
                                <label>lectura inicial *</label>
                            </span>

                            <span className="p-float-label mb-3">
                                <InputNumber
                                    inputId="qrCode"
                                    value={qrCode}
                                    onValueChange={(e) => setQrCode(e.value)}
                                    useGrouping={false}
                                    min={0}
                                />
                                <label>Codigo QR</label>
                            </span>

                            <div>
                                <Button
                                    label={indiceEdicionRemarcador !== null ? "Guardar" : "Agregar"}
                                    icon={indiceEdicionRemarcador !== null ? "pi pi-save" : "pi pi-plus"}
                                    className="p-button-rounded p-button-success p-button-sm"
                                    onClick={handleGuardarRemarcador}
                                    disabled={!tipoRemarcadorId || !proveedorRemarcadorId || lecturaInicial === null || lecturaInicial === undefined}
                                />
                                {indiceEdicionRemarcador !== null && (
                                    <Button
                                        label="Cancelar"
                                        icon="pi pi-times"
                                        className="p-button-rounded p-button-outlined"
                                        onClick={limpiarFormularioRemarcador}
                                    />
                                )}
                            </div>

                            <Card className="mt-2" style={{ width: '100%' }}>
                            {nuevoRemarcadores.length > 0 ? (
                                <DataTable value={nuevoRemarcadores} dataKey="id" className="p-datatable-sm" responsiveLayout="scroll">
                                    <Column field="tipoRemarcador" header="Tipo" />
                                    <Column field="proveedor" header="Proveedor" />
                                    <Column field="qrCode" header="Codigo QR" />
                                    <Column field="lecturaInicial" header="Lectura Inicial" />
                                    <Column
                                        header="Acciones"
                                        body={(rowData) => (
                                            <div className="flex gap-2">
                                                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" onClick={() => handleEditarRemarcador(rowData)} tooltip="Editar" />
                                                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger" onClick={() => handleEliminarRemarcador(rowData)} tooltip="Eliminar" />
                                            </div>
                                        )}
                                    />
                                </DataTable>
                            ) : (
                                <p className="p-text-center">No se han agregado remarcadores.</p>
                            )}
                            </Card>

                        </Fieldset>
                    

                        {/* Sección de Productos Adyacentes */}
                        <Fieldset
                                legend="Productos Adyacentes (opcional)"
                                toggleable
                                collapsed
                                className="mt-4 mb-3"
                            >
                                <p className="text-sm text-muted mb-3">
                                    Seleccione los productos que estarán adyacentes a este nuevo producto.
                                </p>
                                <span className="p-float-label">
                                    <MultiSelect
                                        className="p-inputtext-lg"
                                        id="productosAdyacentes"
                                        value={producto.productosAdyacentes || []}
                                        options={productos.filter(p => 
                                            !producto.productosAdyacentes?.some(selected => selected.id === p.id)
                                        )}
                                        onChange={(e) => setProducto({ ...producto, productosAdyacentes: e.value })}
                                        optionLabel="descripcion"
                                        selectedItemTemplate={(option) => {
                                            return option ? `${option.descripcion}; ` : '';
                                        }}
                                        itemTemplate={(option) => {
                                            return (
                                                <div>
                                                    <span>{option.descripcion}</span>
                                                    <span style={{ marginLeft: '10px', color: '#6c757d', fontSize: '0.9em' }}>
                                                        ({option.metraje} m²)
                                                    </span>
                                                </div>
                                            );
                                        }}
                                        maxSelectedLabels={3}
                                        placeholder={loading2 ? "Cargando productos..." : "Seleccione productos adyacentes"}
                                        disabled={productos.length === 0 || loading2}
                                        filter
                                        showClear
                                    />

                                    <label htmlFor="productosAdyacentes">
                                        {loading2 ? (
                                            <>
                                                <i className="pi pi-spin pi-spinner mr-1"></i>Cargando productos...
                                            </>
                                        ) : (
                                            <>
                                                <i className="pi pi-tags mr-2"></i>Productos Adyacentes
                                            </>
                                        )}
                                    </label>
                                </span>
                                
                                {productos.length === 0 && (
                                    <small className="text-orange-500 mt-1 block">
                                        <i className="pi pi-info-circle mr-1"></i>
                                        No hay productos disponibles para asignar como adyacentes.
                                    </small>
                                )}
                                
                                {/* Lista de productos adyacentes seleccionados */}
                                {producto.productosAdyacentes && producto.productosAdyacentes.length > 0 && (
                                    <div className="mt-3">
                                        <small className="text-muted block mb-2">
                                            <i className="pi pi-check-circle mr-1"></i>
                                            Productos adyacentes seleccionados ({producto.productosAdyacentes.length}):
                                        </small>
                                        <div className="flex flex-wrap gap-2">
                                            {producto.productosAdyacentes.map((prod, index) => (
                                                <Chip 
                                                    key={`${prod.id}-${index}`}
                                                    label={`${prod.descripcion} (${prod.metraje}m²)`}
                                                    className="p-mr-2 p-mb-2"
                                                    removable
                                                    onRemove={() => removerProductoAdyacente(index)}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </Fieldset>
                        {/* Navegación entre steps */}
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button label="" rounded outlined icon="pi pi-arrow-right" iconPos="right" className="" onClick={() => setActiveStep(1)}/>
                        </div>
                    </div>
                )}
                {activeStep === 1 && (
                    <div className="card">
                        <FormCrearProductoFicha
                            ref={fichaRef}
                            perfil={perfil}
                            ficha={ficha}
                        />
                        <div className="flex-space-between">
                            <Button label="" icon="pi pi-arrow-left" rounded outlined onClick={() => setActiveStep(0)} />
                        </div>
                    </div>
                )}
            </Dialog>
        </div>
    );
};

export default FormCrearProducto;
